import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext'
import styled from 'styled-components'
import FeaturedLesson from './FeaturedLesson'

export default function CourseHeader({ course }) {
  const { appState } = useContext(AppContext)
  return (
    <CourseHeaderWrapper className="section single-course-header">
      {course.image && (
        <div className="bg-image-wrapper">
          <img className='section-background-image header-background-image fade-15' src={course.image} alt='course' />
        </div>
      )}
      <div className='section-content thick-padding'>
        <div className='row two-thirds-width'>
          <div className='column'>
            {course.categories && (
              <div className='pre-title'>
                {course.categories.map((cat, index) => (
                  <React.Fragment key={cat.name}>
                    {index > 0 && <span className='spacer'> | </span>}
                    <span className='cat'>{cat.name}</span>
                  </React.Fragment>
                ))}
              </div>
            )}
            <h2 className='title'>{course.title}</h2>
            {!appState.isCoursePurchased && (
              <PriceText>Price: {appState.isCourseFree ? 'Free' : '$' + course.price}</PriceText>
            )}
            {course.description && (
              <div className='subtitle'>{course.description}</div>
            )}

            {appState.latestLesson ? (
              <FeaturedLesson lesson={appState.latestLesson.lesson} unit={appState.latestLesson.unit} />
            ) : (
              <FeaturedLesson lesson={appState.course.units[0].lessons[0]} unit={appState.course.units[0]} />
            )}
          </div>
        </div>
      </div>
    </CourseHeaderWrapper>
  )
}

const CourseHeaderWrapper = styled.section`
  background: var(--dark);
  color: var(--white);
`

const PriceText = styled.div`
  font-size: 1rem;
  opacity: 0.5;
  color: var(--white);
`